export const inputPlayer = (state = [], action) => {
    switch (action.type) {
        case "ADD_INPUT_PLAYER_INFO": {
            return action.payload.inputPlayerInfo;
        }
        default: {
            return state;
        }
    }
};